<template>
    <div>
        <my-header :title="resource.title" :is-back="true"/>
        <div class="banner">
            <van-image :src="resource.cover" class="cover"
                       width="38vw" height="58vw" radius="14px"/>
            <div class="title">{{resource.title}}</div>
            <div class="author">
                {{resource.author}}
            </div>
        </div>
        <!-- 分割线 -->
        <van-divider class="divider"/>
        <!-- 出版社 -->
        <div class="from" v-if="resource.from">{{resource.from}}</div>
        <!-- 简介 -->
        <div class="description-wrap" v-if="resource.description">
            <!-- 小标题 -->
            <div class="description-title">内容简介</div>
            <!-- 内容 -->
            <div class="description">{{resource.description}}</div>
        </div>

        <!-- 评论区 -->
        <div class="description-wrap">
            <div class="description-title">评论</div>
            <comment-list :item-id="resource.firstItem.id"></comment-list>
        </div>

        <div style="height: 70px"></div>

        <!-- 底部操作面板 -->
        <bottom-action-bar btn-text="开始阅读" @btn-click="go2detail"/>
    </div>
</template>

<script>
import LoadResource from "@/views/resource/LoadResource";
import MyHeader from "@/components/myHeader";
import BottomActionBar from "@/components/bottomActionBar";
import CommentList from "@/components/commentList";
import {computed} from 'vue';
export default {
    name: "index",
    components:{BottomActionBar, MyHeader,CommentList},
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        }
    },
    provide(){
        return{
            resourceId:computed(() => this.resource.id),
            resourceItemId:computed(() => {
                if(this.resource){
                    return this.resource.firstItem.id
                }
                return null;
            }),
            enableComment:computed(() =>  this.resource.enableComment)
        }
    },
    setup(props){
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();

        return{
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
        }
    },
    methods:{
        /**
         * 前往详情页
         */
        go2detail(){
            // 前往PDF
            this.$router.push(`/r/book/${this.resource.id}/pdf`)
        }
    }
}
</script>

<style scoped>
.banner{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 9vw;
    height: calc(58vw + 3vw * 2 + 5vw + 4vw);
}
.cover{
    box-shadow:0 1px 18px 2px rgba(56, 56, 56, 0.2);
}
.title,.author{
    width: 90vw;
    margin: 3vw 5vw 0 5vw;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.title{
    height: 6vw;
    font-weight: bold;
}
.author{
    height: 4vw;
    color:#4E4E4E;
    font-size: 0.9rem;
}
.from{
    color:#4E4E4E;
    font-size: 0.9rem;
}
.divider,.description-wrap{
    width: 90vw;
    margin-left: 5vw;
    margin-right: 5vw;
    margin-top: 5vw;
}
.description-title,.description{
    margin-left: 1.5vw;
}
.description{
    color: #4E4E4E;
}
.description-title{
    font-weight: bold;
    margin-bottom: 4vw;
    position: relative;
    height: 6vw;
}
.description-title:before{
    content: '';
    position: absolute;
    left: -4vw;
    top: 1.2vw;
    border-top: 2vw solid transparent;
    border-left: 3vw  solid #3ba0e8;
    border-bottom: 2vw solid transparent;
}
</style>
